export const REDUCER_NAME = 'associate-payment'




// WEBPACK FOOTER //
// ./src/modules/payment/state/associate-payment/const.js